// src/pages/merchant/PromoCodes.js — Codes promo du marchand
// Réutilise la même interface ; le backend limite automatiquement au marchand connecté.
// Maxula
import React from 'react';
import AdminPromoCodes from '../admin/AdminPromoCodes';

export default function MerchantPromoCodes() {
  return <AdminPromoCodes />;
}
